<template>
  <div class="has-border-b filters white">
    <div class="filters-title">
      <v-icon color="gray-6">filter_list</v-icon>
      {{ $t('Common.filters') }}
    </div>

    <div class="filters-item filters-item--search filters-item--reset">
      <v-text-field
        v-model="filters.search"
        :placeholder="$t('Views.CompanyPage.companies.placeholder')"
        prepend-inner-icon="search"
        :disabled="!isSuccess"
        :loading="searchIsLoading"
        color="accent"
        height="36"
        flat
        solo
        clearable
        hide-details
        @input="handleSearch"
      />
    </div>

    <div class="filters-item">
      <MenuItemStatus
        :status="status"
        :items="statusList"
        @change="updateFilters"
      />
    </div>

    <div class="filters-item filters-item__border">
      <MenuItemPeriod
        type="updateDate"
        :status="status"
        @change="updateFilters"
      />
    </div>

    <div class="filters-item filters-item__border">
      <v-checkbox
        v-model="filters.massiveUpdate"
        :label="$t(`${namespace}.filters.sheetActionLabel`)"
        :disabled="!isSuccess"
        hide-details
        class="my-0 py-0 px-2"
        @change="updateFilters()"
      />
    </div>
  </div>
</template>

<script>
import debounce from 'lodash.debounce'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { objectToArray } from 'utils/functions'
import MenuItemStatus from '../MenuItemStatus'
import MenuItemPeriod from '../MenuItemPeriod'

export default {
  name: 'Filters',
  props: {
    status: {
      type: Number,
      default: STATUS_IS_LOADING
    }
  },
  components: {
    MenuItemStatus,
    MenuItemPeriod
  },
  computed: {
    isLoading () {
      return this.status === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.status === STATUS_SUCCESS
    },

    isFailed () {
      return this.status === STATUS_FAILED
    },

    searchIsLoading () {
      return this.isLoading && Boolean(this.filters.search)
    },

    statusList () {
      return objectToArray(this.$t('Views.PaymentStatusPage.filters.statusList'))
    }
  },
  data () {
    return {
      namespace: 'Views.PaymentStatusPage',
      filters: {
        search: null,
        status: null,
        updateDate: null,
        massiveUpdate: false
      }
    }
  },
  methods: {
    emitEvent () {
      this.$emit('change', this.filters)
    },

    handleSearch: debounce(function () {
      this.emitEvent()
    }, 1000),

    updateFilters (val) {
      this.filters = {
        ...this.filters,
        ...val
      }

      this.emitEvent()
    }
  }
}
</script>
